export { default } from './InspDetails.component';
export * from './InspDetails.component';
